import Loader from 'components/loaderComponent';
import { ModalButtonProps } from 'components/modal/modal.interfaces';
import Modal from 'components/modal/modalComponent';

import { useLocation, useNavigate } from 'react-router-dom';
import { componentIds } from 'utilities/constants';
import { useGetComponent } from 'hooks/useGetComponent';
import { MY_APPOINTMENTS_DETAILS } from 'utilities/routes';
import { interpolateReactNodes } from 'utilities/functions';
import queryString from 'query-string';
import { isSummaryForm } from './appointment-details';
import React, { useCallback } from 'react';

const FillInAppointmentModal = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isOpen, setIsOpen] = React.useState(true);
  const appointmentId = location.state?.appointmentId;
  const { data: locale, loading } = useGetComponent({
    componentId: componentIds.FILL_IN_SUMMARY_MODAL,
    locale: 'en',
  });

  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  const handleStart = () => {
    navigate(
      {
        pathname: `${MY_APPOINTMENTS_DETAILS}/${appointmentId}`,
        search: queryString.stringify({ [isSummaryForm]: true }),
      },
      { replace: true },
    );
  };

  const Buttons: ModalButtonProps[] = [
    {
      label: locale?.startFillSummary,
      disabled: false,
      testID: 'start-fill-in-summary',
      onClick: handleStart,
    },
    {
      label: locale?.doItLater,
      disabled: false,
      onClick: handleClose,
      testID: 'do-it-later',
      type: 'underline',
    },
  ];

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      modalDesktopWidth="desktop:max-w-[600px]"
      buttons={Buttons}
      title={locale?.title}
    >
      {loading ? (
        <Loader />
      ) : (
        <div className="text-med-gray-3 font-medium">
          {interpolateReactNodes(locale.aboutYorAppointment, {
            sectionName: (
              <span className="text-btn-black font-semibold">
                {locale?.unfilledSummaries}
              </span>
            ),
          })}
        </div>
      )}
    </Modal>
  );
};

export default FillInAppointmentModal;
